(function() {
    'use strict';

    angular
        .module('virtuallibraryApp')
        .controller('PortalRoleDeleteController',PortalRoleDeleteController);

    PortalRoleDeleteController.$inject = ['$uibModalInstance', 'entity', 'PortalRole'];

    function PortalRoleDeleteController($uibModalInstance, entity, PortalRole) {
        var vm = this;

        vm.portalRole = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            PortalRole.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
